import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import CaseStudies from "./pages/CaseStudies";
import CaseStudiesSubPages from "./pages/CaseStudiesSubPages";
import RequestForQuote from "./pages/RequestForQuote";
import Grievance from "./pages/Grievance";
import BeWorkFromHomeReady from "./pages/BeWorkFromHomeReady";
import FAQs from "./pages/FAQs";
import OutcessClients from "./pages/OutcessClients";
import About from "./pages/About";
import BusinessPartners from "./pages/BusinessPartners";
import Ideology from "./pages/Ideology";
import Careers from "./pages/Careers";
import CurrentOpenings from "./pages/CurrentOpenings";
import Gallery from "./pages/Gallery";
import Industries from "./pages/Industries/Industries";
import CloudSolutions from "./pages/CloudSolutions";
import OmniChannelMarketing from "./pages/Omni-ChannelMarketing";
import BusinessProdSolution from "./pages/BusinessProdSolution";
import BusinessOutsource from "./pages/BusinessOutsource";
import CustomerEngmntSolution from "./pages/CustomerEngmntSolution";
import NotFound from "./pages/NotFound";
import ISOQualityPolicyStatement from "./pages/ISOQualityPolicyStatement";
import ISMSPolicyStatement from "./pages/ISMSPolicyStatement";
import DataPolicy from "./pages/DataPolicy";
import Hire from "./pages/Hire/Hire";
import HireForm from "./pages/Hire/HireForm";
import DigitalClientCaseStudy from "./CaseStudiesSubPages/DigitalClientCaseStudy";
import TelecomClientCaseStudy from "./CaseStudiesSubPages/TelecomClientCaseStudy";
import LeadingEntertainmentClientCaseStudy from "./CaseStudiesSubPages/LeadingEntertainmentClientCaseStudy";
import TransformCSOperationsCaseStudy from "./CaseStudiesSubPages/TransformCSOperationsCaseStudy";
import TransformCSLoanRecoveryCaseStudy from "./CaseStudiesSubPages/TransformCSLoanRecoveryCaseStudy";
import EnhanceCSOperationalEfficiencyCaseStudy from "./CaseStudiesSubPages/EnhanceCSOperationalEfficiencyCaseStudy";
import FinTechCaseStudy from "./CaseStudiesSubPages/FinTechCaseStudy";
import RevolutionizingDebtRecoveryCaseStudy from "./CaseStudiesSubPages/RevolutionizingDebtRecoveryCaseStudy";
import TransformCSForScalableCloudCaseStudy from "./CaseStudiesSubPages/TransformCSForScalableCloudCaseStudy";
import EnhancingTelehealthEngagementCaseStudy from "./CaseStudiesSubPages/EnhancingTelehealthEngagementCaseStudy";
import AmlInsight from "./pages/AmlInsight";
import AmlSolution from "./pages/AmlSolution";
import ClmSolution from "./pages/ClmSolution";
import RedirectToUSSite from "./components/RedirectToUSSite";

function App() {
  useEffect(() => {
    AOS.init({
      once: true,
      duration: 1000,
      easing: "ease",
    });
    AOS.refresh();
  }, []);

  useEffect(() => {
    fetch("https://ipapi.co/json/")
      .then(res => res.json())
      .then(data => {
        if (data.country === "US") {
          window.location.replace("https://outcess.us");
        }
      })
      .catch(() => {});
  }, []);

  return (
    <div className="App">
      <Router basename="/">
        <ScrollToTop />
        <Switch>
          <Route path="/" component={Home} exact />
          <Route path="/case-studies" component={CaseStudies} />
          <Route
            path="/casestudiessubpages/:id/details"
            component={CaseStudiesSubPages}
          />
          <Route path="/contact-us" component={RequestForQuote} />
          <Route path="/grievance" component={Grievance} />
          <Route
            path="/be-work-from-home-ready"
            component={BeWorkFromHomeReady}
          />
          <Route path="/faqs" component={FAQs} />
          <Route path="/outcess-clients" component={OutcessClients} />
          <Route path="/about" component={About} />
          <Route path="/industries" component={Industries} />
          <Route path="/business-partners" component={BusinessPartners} />
          <Route path="/ideology" component={Ideology} />
          <Route path="/careers" component={Careers} />
          <Route path="/hire/:id" component={Hire} />
          <Route path="/hireform" component={HireForm} />
          <Route path="/cloud-solutions" component={CloudSolutions} />
          <Route
            path="/omni-channel-marketing"
            component={OmniChannelMarketing}
          />
          <Route path="/current-openings" component={CurrentOpenings} />
          <Route path="/gallary" component={Gallery} />
          <Route
            path="/business-productivity-solutions"
            component={BusinessProdSolution}
          />
          <Route
            path="/business-process-outsourcing"
            component={BusinessOutsource}
          />
          <Route
            path="/customer-engagement-Solutions"
            component={CustomerEngmntSolution}
          />
          <Route
            path="/isoqualitystatement"
            component={ISOQualityPolicyStatement}
          />
          <Route path="/ismspolicystatement" component={ISMSPolicyStatement} />
          <Route path="/data-policy" component={DataPolicy} />
          {/* Case Study */}
          <Route
            path="/high-performance-contact-center"
            component={DigitalClientCaseStudy}
          />
          <Route
            path="/transform-customer-support"
            component={TelecomClientCaseStudy}
          />
          <Route
            path="/driving-subscription-loyalty"
            component={LeadingEntertainmentClientCaseStudy}
          />
          <Route
            path="/transforming-loan-recovery-customer-service"
            component={TransformCSLoanRecoveryCaseStudy}
          />
          <Route
            path="/enhance-customer-service-and-operational-efficiency"
            component={EnhanceCSOperationalEfficiencyCaseStudy}
          />
          <Route path="/fintechcasestudy" component={FinTechCaseStudy} />
          <Route
            path="/revolutionizing-debt-recovery-for-financial-institution"
            component={RevolutionizingDebtRecoveryCaseStudy}
          />
          <Route
            path="/transform-contact-center-and-customer-support"
            component={TransformCSForScalableCloudCaseStudy}
          />
          <Route
            path="/enhancing-telehealth-engagement"
            component={EnhancingTelehealthEngagementCaseStudy}
          />
          <Route path="/aml-solutions" component={AmlSolution} />
          <Route path="/clm-solutions" component={ClmSolution} />
          <Route
            path="/transforming-customer-service-operations"
            component={TransformCSOperationsCaseStudy}
          />
          {/* The USA section now lives on its own site; send visitors there */}
          <Route path="/us" component={RedirectToUSSite} />
          <Route component={NotFound} />
        </Switch>
      </Router>
    </div>
  );
}

export default App;
